import './Tabs.scss';

import React, { useState } from "react";
export type Tab = {
  id: number;
  label: string;
  content: React.ReactNode;
};

type TabsProps = {
  tabs: Tab[];
  defaultActive?: number;
  activeTab?: number;
  variant?: "default" | "inner";
  onTabChange?: (tab: Tab) => void;
};

const Tabs: React.FC<TabsProps> = ({ tabs, defaultActive = tabs[0].id,
  activeTab: controlledActive, variant = "default", onTabChange
 }) => {
  const [internalActive, setInternalActive] = useState<number>(defaultActive);
  const activeTab = controlledActive ?? internalActive;

  const handleTabClick = (tab: Tab) => {
    setInternalActive(tab.id)
    onTabChange?.(tab)
  }

  return (
    <div className={`tabs tabs--${variant}`}>
      {}
      <div className="tabs__header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tabs__btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {}
      <div className="tabs__content">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`tabs__panel ${
              activeTab === tab.id ? "active" : ""
            }`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
